import React from 'react';

import { useShowGenericErrorSnackbar } from '@ocx-app/hooks/useShowGenericErrorSnackbar';

import { ScreenLoaderBackdrop } from '@ocx/ui';
import { useConfiguration } from '@ocx/data-configuration';
import { usePointExpirationScheduleQuery } from '@ocx/graphql';

import { PointExpirationScheduleLayout } from './point-expiration-schedule.layout';
import { PointExpirationSchedulePage } from './point-expiration-schedule.page';
import { DEFAULT_NOTIFICATION_DAYS } from './utils/group-expirations-by-date';

const DEFAULT_PAGINATION_RESULTS = 10;

export const PointExpirationScheduleController = () => {
  const showGenericErrorSnackbar = useShowGenericErrorSnackbar();
  const { config } = useConfiguration();

  const { data, loading } = usePointExpirationScheduleQuery({
    variables: { first: DEFAULT_PAGINATION_RESULTS },
    onError: () => {
      showGenericErrorSnackbar();
    },
  });

  const expirationSchedule =
    data?.currentCustomer?.membership?.pointExpirationSchedule?.edges?.map((edge) => edge.node) || [];

  const notificationDays = config.loyaltyProgram.pointExpiration.notificationDays ?? DEFAULT_NOTIFICATION_DAYS;

  return (
    <PointExpirationScheduleLayout>
      {loading && <ScreenLoaderBackdrop open />}
      {!loading && (
        <PointExpirationSchedulePage expirationSchedule={expirationSchedule} notificationDays={notificationDays} />
      )}
    </PointExpirationScheduleLayout>
  );
};

export default PointExpirationScheduleController;
